export default __webpack_public_path__ + "static/media/vip-icon.ce00a428.webp";